<template>
  <v-dialog v-model="active" persistent max-width="350">
    <BaseBodyDialog
      :title="title"
      @close="cancel"
      @save="confirm"
    >
      <div class="mt-4" v-if="message" v-html="message"></div>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import BaseBodyDialog from '../basic/dialog/BaseBodyDialog.vue'

export default {
  components: { BaseBodyDialog },
  data: () => ({
    title: '',
    message: '',
    active: false,
    resolver: null,
  }),
  methods: {
    show(title, message) {
      this.title = title
      this.message = message
      this.active = true
      return new Promise((resolve) => {
        this.resolver = resolve
      })
    },
    confirm() {
      this.active = false
      this.resolver(true)
      this.$emit('confirm')
    },
    cancel() {
      this.active = false
      this.resolver(false)
    },
  },
}
</script>
